<!-- 会员升级礼活动页设置 -->
<template>
  <div>
    <jd-title label='活动页设置' type="bold"></jd-title>
    <el-form-item label="活动主题：" label-position="left">
      <div class="common-flex">
        <el-input v-model="formData.theme" maxlength="10" show-word-limit placeholder="请输入" style="width: 320px"
          :disabled="isDisabled"></el-input>
        <el-popover placement="top-start" width="120" trigger="hover">
          <p>不填则C端不展示</p>
          <span slot="reference">
            <i class="new-icon-box greyBg-right-word"></i>
          </span>
        </el-popover>
      </div>
    </el-form-item>
    <el-form-item label="活动说明：" label-position="left">
      <div class="common-flex">
        <el-input v-model="formData.description" maxlength="25" show-word-limit placeholder="请输入" style="width: 320px"
          :disabled="isDisabled"></el-input>
        <el-popover placement="top-start" width="120" trigger="hover">
          <p>不填则C端不展示</p>
          <span slot="reference">
            <i class="new-icon-box greyBg-right-word"></i>
          </span>
        </el-popover>
      </div>
    </el-form-item>
    <el-form-item label="主题文字颜色：" label-position="left">
      <div class="buttonGroup">
        <el-color-picker v-model="formData.wordColor" size="small" :disabled="isDisabled"></el-color-picker>
        <jd-button type="blueText" @click="onTextColorReset" style="margin: 0 12px 0 16px"
          :disabled="backgroundOpacity">重置</jd-button>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ActivityPageSettings',
  props: {
    // 表单数据
    value: {
      type: Object,
      required: true
    },
    // 背景透明度控制（禁用状态）
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
    // 活动数据
    activityData: {
      type: Object,
      default: () => ({
        isStart: false
      })
    },
  },
  data() {
    return {
      formData: this.value
    };
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    },
    formData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  computed: {
    isDisabled() {
      return this.backgroundOpacity;
    }
  },
  methods: {
    // 重置文字颜色
    onTextColorReset() {
      this.$emit('text-color-reset');
    }
  }
}
</script>

<style scoped>
.common-flex {
  display: flex;
  align-items: center;
  gap: 10px;
}

.buttonGroup {
  display: flex;
  align-items: center;
}
</style>